import ApiService from "@/utils/request";

export const aiTalkServe = {
  history(params) {
    return ApiService.query("/qa/v1/chat/", params);
  },
  send(params) {
    return ApiService.post("/qa/v1/chat/send_msg/", params);
  },
  downloadFile(id) {
    return window.open(
      `${process.env.VUE_APP_BASE_URL}/qa/v1/flow_node/${id}/download_file/`
    );
  },
};
